import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.grid-hero__splide' ).length ) {
        $( '.grid-hero__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            gap: '0px',
            autoWidth: true,
            focus: 'center',
            arrows: false,
            pagination: false,
            drag: false,
            autoplay: true,
            interval: 3000,
            pauseOnHover: false,
            pauseOnFocus: false,
            speed: 500,
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'grid-hero', COMPONENT );
} )( app );
